import { useState } from "react";
import { useSelector } from "react-redux";
import Loader from "./loader";
import clsx from 'clsx';

interface GlobalLoaderProps {

}

const GlobalLoader: React.FC<GlobalLoaderProps> = (props) => {
    const isGlobalLoading = useSelector((state: any) => state.page.globalLoading)

    return (
        <>
            <div className={clsx("preloader2", !isGlobalLoading && "preloader2-disable")}>
                <div className="preloader_image" />
            </div>
        </>
    )
}

export default GlobalLoader;